import styled from '@emotion/styled'
import {theme} from '../../../../core/theme'

export const OptionsSelect = styled.select`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  background: ${theme.colors.bg.brand};
  border: none;
  border-radius: ${theme.radii.md};
  padding: ${theme.space[1]} ${theme.space[2]};
  cursor: pointer;
  outline: none;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
